module.exports = __webpack_public_path__ + "static/12_NginxActive-7360b7a318319069fc49cf219cf101d7.png";